import Vue from "vue";
import Vuex from "vuex";
import Bus from "ireal-vue/services/bus.js";

Vue.use(Vuex);
var player_defaults = {
  started: 0,
  isPlaying: false,
  isStarted: false,
  speed: 1,
  duration: 0,
  progress: 0,
  laggingtime: 0,
  lagging: {},
};
export default new Vuex.Store({
  state: {
    language: "en",
    uuid: 0,
    experience: {},
    testParams: {},
    playParams: {},
    test: {},
    player: Object.assign({}, player_defaults),
    poster: "",
    seed: Math.floor(Math.random() * 2),
    listSelected: {},
  },
  mutations: {
    language: (state, payload) => (state.language = payload),
    i18n: (state, payload) => (state.messages = payload),
    experience: (state, experience) => (state.experience = experience),
    test: (state, test) => (state.test = JSON.parse(test)),
    // when user click on "start", api initiliaze the start for histogram and begin the "ireal-start" program
    startPlayer: (state) => {
      state.player = Object.assign({}, player_defaults, {
        isStarted: true,
        isPlaying: true,
        started: new Date().getTime(),
      });
      console.log("Player started");
      state.seed = Math.floor(Math.random() * 2);
      Bus.$emit("ireal-start");
    },
    stopPlayer: (state) => {
      state.player = Object.assign({}, player_defaults);
      console.log("Player stopped");
      Bus.$emit("ireal-stop");
    },
    pausePlayer: (state) => {
      console.log("Player paused");
      state.player = Object.assign({}, state.player, { isPlaying: false });
      Bus.$emit("ireal-pause");
    },
    unPausePlayer: (state) => {
      console.log("Player unpaused");
      state.player = Object.assign({}, state.player, { isPlaying: true });
      Bus.$emit("ireal-un-pause");
    },
    speedPlayer: (state, speed) => {
      state.player = Object.assign({}, state.player, { speed });
      console.log(`Player speed set to ${speed}`);
      Bus.$emit("ireal-speed", speed);
    },
    backPlayer: (state, time) => {
      console.log(`Player backward`);
      Bus.$emit("ireal-back", time);
    },
    forwardPlayer: (state, time) => {
      console.log(`Player forward`);
      Bus.$emit("ireal-forward", time);
    },
    endpointPlayer: (state, time) => {
      console.log(`Player endpoint`);
      Bus.$emit("ireal-endpoint", parseInt(time));
    },
    consumeUuid: (state) => state.uuid++,
    // set parameters in order to complete url for django, data include in brackets after "param":
    // payload is an object in additionnal parameter
    setParam: (state, payload) => {
      state.testParams[payload.param] = payload.value;
      Bus.$emit("value-changed", payload);
    },
    setSelected: (state, payload) => {
      state.listSelected[payload.param] = payload.value;
      state.testParams[payload.param] = payload.value;
      Bus.$emit("selected-changed", payload);
    },
    playParam: (state, payload) => {
      state.playParams = JSON.parse(JSON.stringify(state.testParams));
      //console.log(state.playParams, payload);
    },
    clearParams: (state) => {
      state.testParams = {};
    },
    setProgress: (state, progress) => {
      state.player = Object.assign({}, state.player, { progress });
    },
    setDuration: (state, duration) => {
      if (state.player.duration < duration)
        state.player = Object.assign({}, state.player, { duration });
    },
    setPoster: (state, path) => {
      state.poster = path;
      Bus.$emit("video-poster", path);
    },
    laggingtime: (state, payload) => {
      state.player = Object.assign({}, state.player, { laggingtime: payload });
      Bus.$emit("ireal-fix-lagging-time", payload);
    },
    lagging: (state, payload) => {
      state.player.lagging[payload.uuid] = payload.value;
      state.player = Object.assign({}, state.player);
    },
    changeSrcVideo: (state, payload) => {
      console.log("change-src-video", payload);
      Bus.$emit("change-src-video", payload);
    },
  },
  actions: {},
  getters: {
    language: (state) => state.language,
    messages: (state) => state.messages,
    experience: (state) => state.experience,
    experienceIdentifier: (state) =>
      state.experience !== undefined ? state.experience.identifier : undefined,
    // experienceParams change with the mutation "setParams"
    testParams: (state) => state.testParams,
    playParams: (state) => state.playParams,
    test: (state) => state.test,
    isPlaying: (state) => state.player.isPlaying,
    isStarted: (state) => state.player.isStarted,
    uuid: (state) => state.uuid,
    player: (state) => state.player,
    speed: (state) => state.player.speed,
    progress: (state) => state.player.progress,
    finish: (state) => state.player.progress / state.player.duration,
    isFinished: (state) => state.player.progress === state.player.duration,
    duration: (state) => state.player.duration,
    // TODO: verif utilité de state.poster ( si plusieurs vidéos?)
    poster: (state) => state.poster,
    seed: (state) => state.seed,
    laggingtime: (state) => state.player.laggingtime,
    lagging: (state) => {
      for (var uuid in state.player.lagging) {
        if (state.player.lagging[uuid]) {
          return uuid;
        }
      }
      return false;
    },
    listSelected: (state) => state.listSelected,
  },
});
